import { createFileRoute } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { NotesPage } from '@/pages/settings/notes';

export const Route = createFileRoute('/settings/notes')({
    component: NotesPage,
    pendingComponent: LoadingPage,
});
